"use client";

import { createContext } from "react";
import { DEFAULT_VALUE } from "./useDataHandler";

export const DataHandlerContext = createContext(DEFAULT_VALUE);
